// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyBv-DEI-VkOthbdxD_dhJFDohZARzy8JuY",
    authDomain: "synopsis-3945f.firebaseapp.com",
    projectId: "synopsis-3945f",
    storageBucket: "synopsis-3945f.appspot.com",
    messagingSenderId: "27244605076",
    appId: "1:27244605076:web:b46cc7bd7806835da54e81",
    measurementId: "G-GLC9R5X8SV"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
